import classes from './index.module.css'
function Assignments() {
    const r2BaseUrl = process.env.REACT_APP_R2_BASE_URL
    return (
        <div className={classes.container}>
            <iframe
                allow="autoplay; encrypted-media"
                className={classes.iframeContainer}
                sandbox="allow-scripts allow-same-origin"
                frameBorder="0"
                src={`${r2BaseUrl}/assignment`} title="Embedded Content" width="100%" height="700" />
        </div>
    );
}

export default Assignments;